import { render, staticRenderFns } from "./SACModal.vue?vue&type=template&id=fa94fd3e"
import script from "./SACModal.vue?vue&type=script&lang=js"
export * from "./SACModal.vue?vue&type=script&lang=js"
import style0 from "./SACModal.vue?vue&type=style&index=0&id=fa94fd3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports